// Function loadStepByStepItemBlock loads the StepByStepItemBlock class by dynamically importing the js on demand if needed

export function loadStepByStepItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-step-by-step-item-block-chunk" */ '../widgets/stepByStepItemBlock').then(wg => {

		const { StepByStepItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="StepByStepItemBlock"]');

		if(!$wg) {
			// console.info('StepByStepItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="StepByStepItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new StepByStepItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new StepByStepItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the StepByStepItemBlock widget');

}
